module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "g-hd"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "m-user"
  }, [_c('span', {
    staticClass: "m-wel"
  }), _vm._v(" "), _c('span', {
    staticClass: "m-exit",
    on: {
      "click": _vm.signout
    }
  }, [_vm._v("\n      退出\n    ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-logo"
  }, [_c('span', [_vm._v("LOGO")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0266c0fe!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navbar.vue
// module id = 148
// module chunks = 2